import React from "react";

import { LayersControl, TileLayer, WMSTileLayer, LayerGroup } from 'react-leaflet';
const { Overlay } = LayersControl;

import PropTypes from "prop-types";

function addRetryFailedTiles(event) {
    const delayInMs = 1000;
    const maxRetries = 3;
    let tile = event.tile;
    tile.retries = tile.retries || 0;
    if (tile.retries < maxRetries) {
        setTimeout(function () {
            // eslint-disable-next-line no-self-assign
            tile.src = tile.src; // Reload the tile
            tile.retries += 1;
        }, delayInMs * tile.retries);
    } else {
        console.log(`tile ${tile.src} failed ${tile.retries} times, not retrying.`);
    } 

}

const MapLayersControl = ({luchtfotoLayer, wmsLayers, onlyBaseLayers }) => {
    return (<LayersControl position="topleft">
        {
            <Overlay name={luchtfotoLayer.name} key={luchtfotoLayer.name} checked={luchtfotoLayer.checked}>
                <LayerGroup>

                    <TileLayer
                        key={luchtfotoLayer.name}
                        attribution={luchtfotoLayer.attribution}
                        url={luchtfotoLayer.url}
                        tms={luchtfotoLayer.tms}
                        tileSize={128}
                        zoomOffset={1}
                        onTileerror={addRetryFailedTiles}
                    />
                    <WMSTileLayer
                        key={`Straatnamen`}
                        attribution={"Agentschap Digitaal Vlaanderen"}
                        url={'https://geo.api.vlaanderen.be/GRB/wms'}
                        tms={false}
                        layers={"GRB_SNM"}
                        styles={"GRB_SNM"}
                        format={"image/png"}
                        transparent
                        onTileerror={addRetryFailedTiles}
                        />         
                </LayerGroup>
            </Overlay>}


            {(onlyBaseLayers ? wmsLayers.filter(x => x.isBaseLayer) : wmsLayers).map(x =>
            (<Overlay name={x.name} key={x.name} checked={x.checked}>
                <WMSTileLayer
                    key={x.name}
                    attribution={x.attribution}
                    url={x.url}
                    tms={x.tms}
                    styles={x.styles}
                    layers={x.layers}
                    format={"image/png"}
                    transparent
                    {...(x.opacity !== undefined && { opacity: x.opacity })}
                    {...(x.CQL_FILTER !== undefined && { CQL_FILTER: x.CQL_FILTER })}
                    onTileerror={addRetryFailedTiles}
                    />
            </Overlay>))}
    </LayersControl>);
};

MapLayersControl.propTypes = {
    luchtfotoLayer: PropTypes.object,
    wmsLayers: PropTypes.array,
    onlyBaseLayers: PropTypes.bool
};

export default MapLayersControl;